import React from 'react';

import { useIsEluveAdmin, useIsMlEngineer } from '@eluve/session-helpers';

export interface EluveAdminOrMlEngineerOnlyProps {
  children: React.ReactNode;
}

export const EluveAdminOrMlEngineerOnly: React.FC<
  EluveAdminOrMlEngineerOnlyProps
> = ({ children }) => {
  const isEluveAdmin = useIsEluveAdmin();
  const isMlEngineer = useIsMlEngineer();

  if (!isEluveAdmin && !isMlEngineer) {
    return null;
  }

  return children;
};
